export type StepStatus = "completed" | "current" | "pending";

export const getStepStatus = (
  index: number,
  activeStep: number,
  totalSteps: number
): StepStatus => {
  // activeStep === totalSteps + 1 is the sentinel for "all steps done" (e.g. a
  // final confirmation screen after the last real step) — every step shows
  // completed, none current. Any other out-of-range value still clamps to
  // the nearest real step.
  const isAllCompleted = activeStep === totalSteps + 1;
  const clampedActiveStep = isAllCompleted
    ? activeStep
    : Math.min(Math.max(activeStep, 1), totalSteps);
  const stepNumber = index + 1;

  if (stepNumber < clampedActiveStep) {
    return "completed";
  }

  if (stepNumber === clampedActiveStep) {
    return "current";
  }

  return "pending";
};
